module.exports = __webpack_public_path__ + "img/iconDocuments.e1b7696f.svg";